import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { vars } from '#utils/styles'

export default css`
	:host {
		display: flex;
		flex-direction: column;
	}

	fieldset {
		border: none;
		padding: 0;
		margin: 0;
		min-inline-size: 0;
		display: flex;
		flex-direction: column;
		gap: ${vars(tokens.spacing_xs)};
	}

	/* legend must float to behave as a block in flex/grid fieldsets */
	legend {
		float: left;
		width: 100%;
		padding: 0;
		font-size: ${vars(tokens.text_size_label_default)};
		line-height: ${vars(tokens.line_height_label_default)};
	}

	/* Clear the float so content flows below the legend */
	legend + * {
		clear: left;
	}

	.help {
		cursor: default;
		font-size: ${vars(tokens.text_size_caption_default)};
		line-height: ${vars(tokens.line_height_caption_default)};
		color: ${vars(tokens.color_text_secondary)};
	}

	.checkboxes {
		display: flex;
		flex-direction: column;
		gap: ${vars(tokens.spacing_xs)};
	}

	@media (min-width: 600px) {
		.checkboxes {
			align-items: flex-start;
		}
	}

	.validation {
		display: flex;
		align-items: flex-start;
		cursor: default;
		gap: ${vars(tokens.spacing_xs)};
		color: ${vars(tokens.color_text_error)};
		line-height: calc(18 / 14);
		font-size: 0.875rem;

		.icon {
			margin: -0.2rem 0 0 -0.15rem;
		}
	}
`
